

import React from "react";
import "./About.css";

import { Container } from "react-bootstrap";
const certificates = [
    { src: `${process.env.REACT_APP_BackEndIP}/Static/Certificates/1.jpg`, caption: "Certificate 1" },
    { src: `${process.env.REACT_APP_BackEndIP}/Static/Certificates/2.jpg`, caption: "Certificate 2" },
    { src: `${process.env.REACT_APP_BackEndIP}/Static/Certificates/3.jpg`, caption: "Certificate 3" },
    { src: `${process.env.REACT_APP_BackEndIP}/Static/Certificates/4.jpg`, caption: "Certificate 4" },
    { src: `${process.env.REACT_APP_BackEndIP}/Static/Certificates/5.jpg`, caption: "Certificate 5" },
    { src: `${process.env.REACT_APP_BackEndIP}/Static/Certificates/6.jpg`, caption: "Certificate 6" },
    { src: `${process.env.REACT_APP_BackEndIP}/Static/Certificates/7.jpg`, caption: "Certificate 7" },
    { src: `${process.env.REACT_APP_BackEndIP}/Static/Certificates/8.jpg`, caption: "Certificate 8" },
];

const About = () => {
    return (
        <Container fluid="xl" className="Cointainer02">
            <div className="about">
                <div className="section">
                    <h2 className="Titel01">Artist Bio</h2>
                    <p className="Detailes01">
                        Hello art lovers and aficionados! My name is Ami Gadhiya, and I am thrilled to welcome you to my online gallery where imagination meets canvas!
                        As an artist, I draw inspiration from the world around me – from the vibrant colors of nature to the intricate patterns of everyday life. Each stroke of my brush or click of my mouse is a reflection of my emotions, experiences, and perspective on the world.
                        I invite you to explore my portfolio, where you'll find a diverse range of artworks spanning different styles, themes, and mediums. But more than just showcasing my work, I hope to foster a sense of community and connection among fellow artists and enthusiasts.
                        Let's inspire each other, share our stories, and celebrate the boundless creativity that makes the world a more beautiful place.
                        Feel free to reach out with any questions or special requests—I'm here to make your art-buying experience as delightful as possible. "Happy exploring!"
                    </p>
                </div>

                <div className="section">
                    <h2 className="Titel01">Accolades & Recognition</h2>
                    <div className="certificates-grid">
                        {certificates.map((cert, index) => (
                            <div className="certificate-item" key={index}>
                                <img src={cert.src} alt={cert.caption} className="certificate-image" />
                                {/* <div className="certificate-caption">{cert.caption}</div> */}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="section contact-section">
                    <h2 className="Titel01">Contact</h2>
                    <p className="Detailes01">
                        📧 Email: <a href="mailto:Ami.Artsy00@gmail.com">Ami.Artsy00@gmail.com</a><br />
                        📸 Instagram: <a href="https://instagram.com/ami_.artsy" target="_blank" rel="noopener noreferrer">@ami_.artsy</a>
                    </p>
                </div>
            </div>
        </Container>
    );
};

export default About;
